/**
 * Befehlskanal P2 — die Wörter zwischen Server und Seite für den Beleg (ohne Node-Abhängigkeit, die Seite importiert diese Datei).
 * Der Server entscheidet (server/beleg-route.ts); die Seite fordert an und zeigt nur das Ergebnis. Der Beleg selbst geht NIE an die Seite.
 */
export const BELEG_PFAD = "/api/befehlskanal/beleg";
/** Der Kopf, den nur die eigene Seite setzt (server/eigene-seite.ts), mit eigenem Wert. */
export const BELEG_KOPF_WERT = "beleg-ausstellen";
export const BELEG_GUELTIG_MINUTEN = 10;

/** Feste Fehlergründe der Route — die Seite übersetzt sie in Worte (nie Text vom Server anzeigen). */
export const BELEG_FEHLER = [
  "aus",
  "nicht-erlaubt",
  "herkunft-unzulaessig",
  "not-logged-in",
  "auth-revoked",
  "ungueltig",
  "unbekannt",
  "abgelaufen",
  "beantwortet",
  "hash-falsch",
  "limit",
  "zimmermann-hoert-nicht",
  "nicht-bereit",
] as const;
export type BelegFehlerCode = (typeof BELEG_FEHLER)[number];

export interface BelegAntwortOk {
  ok: true;
  kennung: string;
  ergebnis: "ja" | "nein";
  /** UTC-Sekunden. */
  gueltig_bis: number;
}
export interface BelegAntwortFehler {
  ok: false;
  error: BelegFehlerCode;
}

/** Die Wörter auf der Karte je Fehler (Text kommt nie vom Server). */
export function belegFehlerText(code: string): string {
  switch (code) {
    case "aus":
      return "Belege sind ausgeschaltet.";
    case "abgelaufen":
      return "Die Frage ist abgelaufen.";
    case "beantwortet":
      return "Diese Frage ist schon beantwortet.";
    case "limit":
      return "Zu viele Belege, bitte später wieder.";
    case "zimmermann-hoert-nicht":
      return "Zimmermann hört gerade nicht zu, bitte später noch einmal.";
    case "unbekannt":
      return "Diese Frage kennt der Server nicht (mehr).";
    case "hash-falsch":
      return "Der Fragetext passt nicht zur Frage.";
    case "not-logged-in":
    case "auth-revoked":
      return "Bitte neu anmelden.";
    default:
      return "Beleg nicht möglich.";
  }
}
